import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const GiftCardLink = ({ withUpsellingRedirect }) => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to={`${
          withUpsellingRedirect ? '/dashboard/upselling' : '/dashboard/building-dashboard'
        }/rewards`}
      >
        <span>
          {t('navbar:upsellingLinks.giftCardsAndRewards')}
          <NavigationLabel type={NAVIGATION_LABELS.NEW} locked={withUpsellingRedirect} />
        </span>
      </NavLink>
    </div>
  )
}

GiftCardLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default GiftCardLink
